import { toast } from 'react-hot-toast';
import type { ToastOptions as HotToastOptions } from 'react-hot-toast';

/**
 * Options accepted by the helpers below. These used to wrap react-toastify, so the
 * `autoClose` / `toastId` spellings are kept as aliases for its react-hot-toast
 * equivalents (`duration` / `id`) — existing call sites keep working unchanged.
 */
export interface ToastOptions extends HotToastOptions {
  /** @deprecated Use `duration`. */
  autoClose?: number;
  /** @deprecated Use `id`. */
  toastId?: string;
}

function toHotToastOptions(options?: ToastOptions): HotToastOptions {
  if (!options) return {};
  const { autoClose, toastId, ...rest } = options;
  return {
    ...rest,
    ...(autoClose !== undefined && rest.duration === undefined ? { duration: autoClose } : {}),
    ...(toastId !== undefined && rest.id === undefined ? { id: toastId } : {}),
  };
}

export const toastSuccess = (
  message: string,
  options?: ToastOptions,
  style?: React.CSSProperties
) => {
  toast.success(message, {
    ...toHotToastOptions(options),
    ...(style ? { style } : {}),
  });
};

export const toastError = (message: string, options?: ToastOptions) => {
  toast.error(message, toHotToastOptions(options));
};

export const toastWarning = (message: string, options?: ToastOptions) => {
  // react-hot-toast has no warning variant — a plain toast with a warning icon.
  toast(message, { icon: '⚠️', ...toHotToastOptions(options) });
};
